import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'organizations'

export default {
  getOrganizations(settings = {}) {
    return Repository.get(action + getParamsUrl(settings))
  },
  getExporters() {
    return Repository.get(action + '/exporters')
  },
  updateItem(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  getBidRequiredDocuments(org_id) {
    return Repository.get(action + '/bids-documents?org_id=' + org_id)
  },
}
